import { FullOffer } from '../offer/offer';

export class FilterPopUpTable {
    column: string;
    values: any[];

    constructor(column: string = '', values: any[] = []) {
        this.column = column;
        this.values = values;
    }
}

export class DataFiltered {
    data: FullOffer;
    isInFilter: boolean;

    constructor(data: FullOffer, isInFilter: boolean) {
        this.data = data;
        this.isInFilter = isInFilter;
    }
}

export class ValueCheckbox {
    value: string;
    isCheck: boolean;
}
